// ======================================================================
// File Name       : ReduxFormUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import moment from 'moment';
import Calendar from 'rc-calendar';
import 'rc-calendar/assets/index.css';
import Picker from 'rc-calendar/lib/Picker';
import 'rc-time-picker/assets/index.css';
import TimePickerPanel from 'rc-time-picker/lib/Panel';
import React from 'react';
import { Col, Form, FormControl, InputGroup } from 'react-bootstrap';
import { Field } from 'redux-form';
import SelectBox from '../components/SelectBox';
import TreeView from '../components/Tree';
import {
  DEFAULT_DATE_FORMAT,
  DEFAULT_DATE_FORMAT_NO_MINUTE,
  DEFAULT_DATE_FORMAT_SHORT_DETAIL,
  ERROR_TYPE,
  MAX_INT,
  VALIDATE_TYPE,
} from '../constants/index';
import * as MessageTemplate from '../constants/MessageTemplate';
import {
  LIVE_START_MIN_DATE,
  MAX_DATE,
  MIN_DATE,
  MIN_MAX_DATE_TXT,
  PRECENT_DAY,
  WRONG_CREATE_DATE_TXT,
  handleCalendarIconClick,
  jaJPCustom,
  validateDateTime
} from '../utils/index';
import * as ValidateUtils from '../utils/ValidateUtils';

require('moment/locale/ja');

class RenderField extends React.Component {
  constructor(props) {
    super(props);
    this.REQUIRED = this.REQUIRED.bind(this);
    this.NUMERIC = this.NUMERIC.bind(this);
    this.ID = this.ID.bind(this);
    this.ID_INCLUDING_HYPHEN = this.ID_INCLUDING_HYPHEN.bind(this);
    this.CHECK_OVERLAP = this.CHECK_OVERLAP.bind(this);
    this.INVOICE_NUMBER = this.INVOICE_NUMBER.bind(this);
    this.EMAIL = this.EMAIL.bind(this);
    this.REAL_NUMBER = this.REAL_NUMBER.bind(this);
    this.COURSE_BOX_ID = this.COURSE_BOX_ID.bind(this);
    this.DRILL_QUESTION_SETTING = this.DRILL_QUESTION_SETTING.bind(this);
    this.IMG_FILE = this.IMG_FILE.bind(this);
    this.MAX_NUMBER = this.MAX_NUMBER.bind(this);
    this.URL = this.URL.bind(this);
    this.DATE_TIME = this.DATE_TIME.bind(this);
    this.DATE_TIME_MIN_MAX = this.DATE_TIME_MIN_MAX.bind(this);
    this.getValidationFunctions = this.getValidationFunctions.bind(this);
    this.formatDateTime = this.formatDateTime.bind(this);
    this.VIDEO_SIZE = this.VIDEO_SIZE.bind(this);
    this.DOCUMENT_SIZE = this.DOCUMENT_SIZE.bind(this);
    this.QUESTION_ANSWER = this.QUESTION_ANSWER.bind(this);
    this.MIN_ANSWER_LIST = this.MIN_ANSWER_LIST.bind(this);
    this.REPORT_TIME_MIN_MAX = this.REPORT_TIME_MIN_MAX.bind(this);
    this.DATE_TIME_WITH_LIMIT = this.DATE_TIME_WITH_LIMIT.bind(this);
    this.REQUIRED_ARRAY = this.REQUIRED_ARRAY.bind(this);
    this.REQUIRED_FILE = this.REQUIRED_FILE.bind(this);
    this.NOT_ACCEPT_FILE = this.NOT_ACCEPT_FILE.bind(this);
    this.ACCEPT_FILE = this.ACCEPT_FILE.bind(this);
    this.SAME_MINUTE = this.SAME_MINUTE.bind(this);
    this.SAME_DAY = this.SAME_DAY.bind(this);
    this.MAX_ARRAY_LENGTH = this.MAX_ARRAY_LENGTH.bind(this);
    this.MAX_DURATION = this.MAX_DURATION.bind(this);
    this.MIN_1_MAX_NUMBER = this.MIN_1_MAX_NUMBER.bind(this);
    this.errorType = ERROR_TYPE.ERROR;
    this.minMaxDateTxt = props.minMaxDateTxt ? props.minMaxDateTxt : MIN_MAX_DATE_TXT;
    this.formatString = this.formatString.bind(this);
    this.formatBoolean = this.formatBoolean.bind(this);
    this.dateFormat = DEFAULT_DATE_FORMAT;
    this.CONFIG_FILE_SIZE = this.CONFIG_FILE_SIZE.bind(this);
    this.REQUIRED_ARRAY_LIST_ITEM_START_CONDITION = this.REQUIRED_ARRAY_LIST_ITEM_START_CONDITION.bind(this);
  }

  ACCEPT_FILE(value, allValues, props) {
    let fileToCheck = null;
    if (!value || !this.props.acceptCheck) {
      return undefined;
    }
    if (value instanceof File) fileToCheck = value;
    if (value && value.length && value[0] instanceof File) fileToCheck = value[0];
    if (!fileToCheck) return undefined;
    if (!fileToCheck.name) return undefined;
    const acceptTypeList = this.props.acceptCheck.split(',');
    const fileType = getFileExtension(fileToCheck.name);
    const fileTypeConvert = fileType.toLowerCase();
    if (acceptTypeList.indexOf(fileTypeConvert) < 0) {
      this.errorType = ERROR_TYPE.ERROR;
      return MessageTemplate.MSG_FILE_TYPE_INVALID;
    }
    return undefined;
  }

  NOT_ACCEPT_FILE(value, allValues, props) {
    let fileToCheck = null;
    if (!value || !this.props.notAccept) {
      return undefined;
    }
    if (value instanceof File) fileToCheck = value;
    if (value && value.length && value[0] instanceof File) fileToCheck = value[0];
    if (!fileToCheck) return undefined;
    if (!fileToCheck.name) return undefined;
    const notAcceptTypeList = this.props.notAccept.split(',');
    const fileType = getFileExtension(fileToCheck.name);
    if (notAcceptTypeList.indexOf(fileType) > -1) {
      this.errorType = ERROR_TYPE.ERROR;
      return MessageTemplate.MSG_FILE_TYPE_INVALID_NOT_ACCEPT;
    }
    return undefined;
  }

  REQUIRED(value, allValues, props) {
    if (value === undefined || value === null || value === '') {
      this.errorType = ERROR_TYPE.EMPTY;
      return messageTemplate('', MessageTemplate.W_REQUIRED);
    }
    return undefined;
  }

  NUMERIC(value) {
    const isValid = ValidateUtils.validNumFormat(value);
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageTemplate('', MessageTemplate.MSG_NUMERIC_INVALID);
    }
    return undefined;
  }

  ID(value) {
    const isValid = ValidateUtils.validIdFormat(value);
    if (value && !isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageTemplate('', MessageTemplate.W_PATTERN_INCORRECT);
    }
    return undefined;
  }

  ID_INCLUDING_HYPHEN(value) {
    const isValid = ValidateUtils.validIdFormat2(value);
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageTemplate('', MessageTemplate.MSG_ID_INCLUDING_HYPHEN_INVALID);
    }
    return undefined;
  }

  CHECK_OVERLAP(value, allValues, props) {
    const { isOverlap } = this.props;
    const isValid = isOverlap;
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageTemplate('', MessageTemplate.MSG_OVERLAP);
    }
    return undefined;
  }

  INVOICE_NUMBER(value, allValues, props) {
    let isValid = true;
    isValid = ValidateUtils.validInvoiceNumber(value);
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return MessageTemplate.MSG_INVOICE_NUMBER_INVALID;
    }
    return MessageTemplate.MSG_INVOICE_NUMBER_VALID;
  }

  EMAIL(value, allValues, props) {
    let isValid = true;
    isValid = ValidateUtils.validEmail(value);
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return MessageTemplate.MSG_EMAIL_INVALID;
    }
    return MessageTemplate.MSG_EMAIL_VALID;
  }

  REAL_NUMBER(value, allValues, props) {
    let isValid = true;
    isValid = ValidateUtils.validRealNumber(value);
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return MessageTemplate.MSG_REAL_NUMBER_INVALID;
    }
    return MessageTemplate.MSG_REAL_NUMBER_VALID;
  }

  COURSE_BOX_ID(value, allValues, props) {
    let isValid = true;
    isValid = ValidateUtils.validCouseBoxIdFormat(value);
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return MessageTemplate.MSG_COURSE_BOX_ID_INVALID;
    }
    return MessageTemplate.MSG_COURSE_BOX_ID_VALID;
  }

  DRILL_QUESTION_SETTING(value, allValues, props) {
    let isValid = true;
    isValid = ValidateUtils.validDrillQuestionSetting(value);
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return MessageTemplate.MSG_DRILL_QUESTION_SETTING_INVALID;
    }
    return MessageTemplate.MSG_DRILL_QUESTION_SETTING_VALID;
  }

  IMG_FILE(value, allValues, props) {
    let isValid = true;
    isValid = ValidateUtils.validImageFile(value);
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageTemplate('', MessageTemplate.W_FILE_EXTENSION_INCORRECT);
    }
    return undefined;
  }

  DOCUMENT_SIZE(value, allValues, props) {
    let isValid = true;
    if (allValues && allValues.documentSize) {
      isValid = ValidateUtils.validDocumentUploadSize(allValues.documentSize);
    }
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageTemplate('', MessageTemplate.MSG_DOCUMENT_UPLOAD_SIZE_INVALID);
    }
    return undefined;
  }

  VIDEO_SIZE(value, allValues, props) {
    let isValid = true;
    if (value && value[0] && value[0].size) {
      isValid = ValidateUtils.validVideoUploadSize(value[0].size);
    }
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageTemplate('', MessageTemplate.MSG_VIDEO_UPLOAD_SIZE_INVALID);
    }
    return undefined;
  }

  CONFIG_FILE_SIZE(value, allValues, props) {
    let isValid = true;
    if (value && value[0] && value[0].size) {
      isValid = ValidateUtils.validConfigFileUploadSize(value[0].size);
    }
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageTemplate('', MessageTemplate.MSG_CONFIG_FILE_UPLOAD_SIZE_INVALID);
    }
    return undefined;
  }

  QUESTION_ANSWER(value, allValues, props) {
    let isValid = true;
    if (allValues) {
      isValid = ValidateUtils.validQuestionAnswer(value);
    }
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageTemplate('', MessageTemplate.MSG_QUESTION_ANSWER);
    }
    return undefined;
  }

  MIN_ANSWER_LIST(value, allValues, props) {
    let isValid = true;
    if (allValues) {
      isValid = ValidateUtils.minMultiAnswer(value);
    }
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageTemplate('', MessageTemplate.MSG_MIN_ANSWER_LIST);
    }
    return undefined;
  }

  MAX_NUMBER(value, allValues, props) {
    const { maxNumber } = this.props;
    let isValid = true;
    isValid = ValidateUtils.validNumberRange(value, 0, maxNumber);
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageMaxNumberTemplate('', maxNumber, MessageTemplate.W_MAX_NUMBER);
    }
    return undefined;
  }

  MIN_1_MAX_NUMBER(value, allValues, props) {
    const { maxNumber = MAX_INT } = this.props;
    let isValid = true;
    isValid = ValidateUtils.validNumberRange(value, 1, maxNumber);
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageMinMaxNumberTemplate('', 1 , maxNumber, MessageTemplate.W__MIN_MAX_NUMBER);
    }
    return undefined;
  }

  URL(value, allValues, props) {
    let isValid = true;
    isValid = ValidateUtils.validUrl(value);
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageTemplate('', MessageTemplate.W_PATTERN_INCORRECT);
    }
    return undefined;
  }

  DATE_TIME(value, allValues, props) {
    const isValid = validateDateTime(value, this.dateFormat, this.minMaxDateTxt);
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return '公開期間に入力できない文字が含まれています。';
    }
    return undefined;
  }

  SAME_MINUTE(value, allValues, props) {
    let isValid = true;
    const dateFrom = getPropertyByKeyPath(allValues, this.props.keyDateFrom);
    const dateTo = getPropertyByKeyPath(allValues, this.props.keyDateTo);
    const shouldNotCheck =
      !(dateFrom && dateTo) || dateFrom === this.minMaxDateTxt || dateTo === this.minMaxDateTxt;
    if (shouldNotCheck) {
      return undefined;
    }
    if (isValid) {
      const mDateFrom = dateFrom ? moment(dateFrom).startOf('minute') : null;
      const mDateTo = dateTo ? moment(dateTo).startOf('minute') : null;
      if (mDateFrom && mDateTo) {
        isValid = mDateFrom.isBefore(mDateTo);
      }
    }
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return this.props.wrongPeriodTxt ? this.props.wrongPeriodTxt : WRONG_CREATE_DATE_TXT;
    }
    return undefined;
  }

  SAME_DAY(value, allValues, props) {
    let isValid = true;
    const dateFrom = getPropertyByKeyPath(allValues, this.props.keyDateFrom);
    const dateTo = getPropertyByKeyPath(allValues, this.props.keyDateTo);
    const shouldNotCheck =
      !(dateFrom && dateTo) || dateFrom === this.minMaxDateTxt || dateTo === this.minMaxDateTxt;
    if (shouldNotCheck) {
      return undefined;
    }
    if (isValid) {
      const mDateFrom = dateFrom ? moment(dateFrom).startOf('day') : null;
      const mDateTo = dateTo ? moment(dateTo).startOf('day') : null;
      if (mDateFrom && mDateTo) {
        isValid = mDateFrom.isSame(mDateTo);
      }
    }
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return MessageTemplate.MSG_SAME_DAY;
    }
    return undefined;
  }

  DATE_TIME_MIN_MAX(value, allValues) {
    let isValid = true;
    const dateFrom = getPropertyByKeyPath(allValues, this.props.keyDateFrom);
    const dateTo = getPropertyByKeyPath(allValues, this.props.keyDateTo);
    const shouldNotCheck =
      !(dateFrom && dateTo) || dateFrom === this.minMaxDateTxt || dateTo === this.minMaxDateTxt;
    if (shouldNotCheck) {
      return undefined;
    }
    if (isValid) {
      const mDateFrom = dateFrom ? moment(dateFrom) : null;
      const mDateTo = dateTo ? moment(dateTo) : null;
      if (mDateFrom && mDateTo) {
        isValid = mDateFrom.isSameOrBefore(mDateTo);
      }
    }
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return this.props.wrongPeriodTxt ? this.props.wrongPeriodTxt : WRONG_CREATE_DATE_TXT;
    }
    return undefined;
  }

  REPORT_TIME_MIN_MAX(value, allValues) {
    let isValid = true;
    const reportDeadline = getPropertyByKeyPath(allValues, this.props.keyReportDeadline);
    const reportReturnPlanDate = getPropertyByKeyPath(
      allValues,
      this.props.keyReportReturnPlanDate,
    );
    const shouldNotCheck =
      !(reportDeadline && reportReturnPlanDate) ||
      reportDeadline === this.props.reportDeadlineTxt ||
      reportReturnPlanDate === this.props.returnPlanDateTxt;
    if (shouldNotCheck) {
      return undefined;
    }
    const mDateFrom = reportDeadline ? moment(reportDeadline).startOf('day') : null;
    const mDateTo = reportReturnPlanDate ? moment(reportReturnPlanDate).startOf('day') : null;
    if (mDateFrom && mDateTo) {
      isValid = mDateFrom.isSameOrBefore(mDateTo);
    }
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return this.props.wrongPeriodTxt ? this.props.wrongPeriodTxt : WRONG_CREATE_DATE_TXT;
    }
    return undefined;
  }

  DATE_TIME_WITH_LIMIT(value, allValues, props) {
    let isValid = true;
    const shouldNotCheck = !value || value === this.minMaxDateTxt;
    if (shouldNotCheck) {
      return undefined;
    }
    if (isValid) {
      const mDate = value ? moment(value) : null;
      if (mDate) {
        if (this.props.minDate) {
          isValid = mDate.isSameOrAfter(this.props.minDate);
        }
        if (this.props.maxDate) {
          isValid = mDate.isSameOrBefore(this.props.maxDate);
        }
      }
    }
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return this.props.wrongPeriodTxt ? this.props.wrongPeriodTxt : WRONG_CREATE_DATE_TXT;
    }
    return undefined;
  }

  REQUIRED_ARRAY(value, allValues, props) {
    const arrayToCheck = getPropertyByKeyPath(allValues, this.props.keyArrayToCheck);
    if (!arrayToCheck || !Object.keys(arrayToCheck).length) {
      this.errorType = ERROR_TYPE.EMPTY;
      return messageTemplate('', MessageTemplate.W_REQUIRED);
    }
    return undefined;
  }

  REQUIRED_FILE(value, allValues, props) {
    const arrayToCheck = getPropertyByKeyPath(allValues, this.props.keyArrayToCheck);
    const checkFile = arrayToCheck && arrayToCheck.length ? arrayToCheck[0] : arrayToCheck;
    if (!arrayToCheck || !(checkFile instanceof File)) {
      this.errorType = ERROR_TYPE.EMPTY;
      return messageTemplate('', MessageTemplate.W_REQUIRED);
    }
    return undefined;
  }

  MAX_ARRAY_LENGTH(value, allValues, props) {
    const arrayToCheck = getPropertyByKeyPath(allValues, this.props.keyArrayToCheck);
    if (!arrayToCheck || Object.keys(arrayToCheck).length > this.props.maxLength) {
      this.errorType = ERROR_TYPE.EMPTY;
      return messageTemplate('', MessageTemplate.MSG_LIMIT_ARRAY);
    }
    return undefined;
  }

  MAX_DURATION(value, allValues, props) {
    let isValid = true;
    const dateFrom = getPropertyByKeyPath(allValues, this.props.keyDateFrom);
    const dateTo = getPropertyByKeyPath(allValues, this.props.keyDateTo);
    const maxDuration = this.props.maxDuration || 0;
    const shouldNotCheck =
      !(dateFrom && dateTo) || dateFrom === this.minMaxDateTxt || dateTo === this.minMaxDateTxt;
    if (shouldNotCheck) {
      return undefined;
    }
    if (isValid) {
      const mDateFrom = dateFrom ? moment(dateFrom).startOf('minute') : null;
      const mDateTo = dateTo ? moment(dateTo).startOf('minute') : null;
      if (mDateFrom && mDateTo) {
        isValid = (mDateTo.diff(mDateFrom, 'minutes') <= maxDuration);
      }
    }
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageTemplate(maxDuration, MessageTemplate.MSG_MAX_MINUTE);
    }
    return undefined;
  }

  // sprint_20230522_tma START
  REQUIRED_ARRAY_LIST_ITEM_START_CONDITION(value, allValues, props) {
    const arrayToCheck = getPropertyByKeyPath(allValues, this.props.keyArrayToCheck);
    if (!arrayToCheck || !Object.keys(arrayToCheck).length) {
      this.errorType = ERROR_TYPE.EMPTY;
      return messageTemplate('', MessageTemplate.W_REQUIRED_ITEM_LIST_START_CONDITION);
    }
    return undefined;
  }
  // sprint_20230522_tma END

  getValidationFunctions(validates) {
    const validateFunctions = [];
    for (const key in validates) {
      switch (validates[key]) {
        case VALIDATE_TYPE.REQUIRED: {
          validateFunctions.push(this.REQUIRED);
          break;
        }
        case VALIDATE_TYPE.NUMERIC: {
          validateFunctions.push(this.NUMERIC);
          break;
        }
        case VALIDATE_TYPE.ID: {
          validateFunctions.push(this.ID);
          break;
        }
        case VALIDATE_TYPE.ID_INCLUDING_HYPHEN: {
          validateFunctions.push(this.ID_INCLUDING_HYPHEN);
          break;
        }
        case VALIDATE_TYPE.NUMBERIC_OVERLAP:
        case VALIDATE_TYPE.ID_CHECKOVERLAP: {
          validateFunctions.push(this.CHECK_OVERLAP);
          break;
        }
        case VALIDATE_TYPE.PASSWORD:
          break;
        case VALIDATE_TYPE.INVOICE_NUMBER: {
          validateFunctions.push(this.INVOICE_NUMBER);
          break;
        }
        case VALIDATE_TYPE.EMAIL: {
          validateFunctions.push(this.EMAIL);
          break;
        }
        case VALIDATE_TYPE.REAL_NUMBER: {
          validateFunctions.push(this.REAL_NUMBER);
          break;
        }
        case VALIDATE_TYPE.COURSE_BOX_ID: {
          validateFunctions.push(this.COURSE_BOX_ID);
          break;
        }
        case VALIDATE_TYPE.DRILL_QUESTION_SETTING: {
          validateFunctions.push(this.DRILL_QUESTION_SETTING);
          break;
        }
        case VALIDATE_TYPE.IMG_FILE: {
          validateFunctions.push(this.IMG_FILE);
          break;
        }
        case VALIDATE_TYPE.URL: {
          validateFunctions.push(this.URL);
          break;
        }
        case VALIDATE_TYPE.MAX_NUMBER: {
          validateFunctions.push(this.MAX_NUMBER);
          break;
        }
        case VALIDATE_TYPE.DATE_TIME: {
          validateFunctions.push(this.DATE_TIME);
          break;
        }
        case VALIDATE_TYPE.VIDEO_SIZE: {
          validateFunctions.push(this.VIDEO_SIZE);
          break;
        }
        case VALIDATE_TYPE.DOCUMENT_SIZE: {
          validateFunctions.push(this.DOCUMENT_SIZE);
          break;
        }
        case VALIDATE_TYPE.QUESTION_ANSWER: {
          validateFunctions.push(this.QUESTION_ANSWER);
          break;
        }
        case VALIDATE_TYPE.MIN_ANSWER_LIST: {
          validateFunctions.push(this.MIN_ANSWER_LIST);
          break;
        }
        case VALIDATE_TYPE.DATE_TIME_MIN_MAX: {
          validateFunctions.push(this.DATE_TIME_MIN_MAX);
          break;
        }
        case VALIDATE_TYPE.REPORT_TIME_MIN_MAX: {
          validateFunctions.push(this.REPORT_TIME_MIN_MAX);
          break;
        }
        case VALIDATE_TYPE.DATE_TIME_WITH_LIMIT: {
          validateFunctions.push(this.DATE_TIME_WITH_LIMIT);
          break;
        }
        case VALIDATE_TYPE.REQUIRED_ARRAY: {
          validateFunctions.push(this.REQUIRED_ARRAY);
          break;
        }
        case VALIDATE_TYPE.REQUIRED_FILE: {
          validateFunctions.push(this.REQUIRED_FILE);
          break;
        }
        case VALIDATE_TYPE.ACCEPT_FILE: {
          validateFunctions.push(this.ACCEPT_FILE);
          break;
        }
        case VALIDATE_TYPE.NOT_ACCEPT_FILE: {
          validateFunctions.push(this.NOT_ACCEPT_FILE);
          break;
        }
        case VALIDATE_TYPE.SAME_MINUTE: {
          validateFunctions.push(this.SAME_MINUTE);
          break;
        }
        case VALIDATE_TYPE.SAME_DAY: {
          validateFunctions.push(this.SAME_DAY);
          break;
        }
        case VALIDATE_TYPE.MAX_ARRAY_LENGTH: {
          validateFunctions.push(this.MAX_ARRAY_LENGTH);
          break;
        }
        case VALIDATE_TYPE.MAX_DURATION: {
          validateFunctions.push(this.MAX_DURATION);
          break;
        }
        case VALIDATE_TYPE.MIN_1_MAX_NUMBER: {
          validateFunctions.push(this.MIN_1_MAX_NUMBER);
          break;
        }
        case VALIDATE_TYPE.CONFIG_FILE_SIZE: {
          validateFunctions.push(this.CONFIG_FILE_SIZE);
          break;
        }
        // sprint_20230522_tma START
        case VALIDATE_TYPE.REQUIRED_ARRAY_LIST_ITEM_START_CONDITION: {
          validateFunctions.push(this.REQUIRED_ARRAY_LIST_ITEM_START_CONDITION);
          break;
        }
        // sprint_20230522_tma END
        default: {
          break;
        }
      }
    }
    return validateFunctions;
  }

  getFieldComponent(type) {
    let fieldComponent = TextBox;
    switch (type) {
      case 'radio':
      case 'checkbox':
        fieldComponent = 'input';
        break;
      case 'file':
        fieldComponent = FileUpload;
        break;
      case 'datetime':
        fieldComponent = DateTimeInput;
        break;
      case 'selectbox':
        fieldComponent = SelectInput;
        break;
      case 'textarea':
        fieldComponent = TextArea;
        break;
      case 'batchimport':
        fieldComponent = BatchImport;
        break;
      case 'dateTimeMinMax':
        fieldComponent = DateTimeMinMax;
        break;
      case 'tree':
        fieldComponent = TreeComponent;
        break;
      case 'thumbnailimport':
        fieldComponent = ThumbnailImport;
        break;
      case 'requiredarray':
        fieldComponent = RequiredArray;
        break;
      default:
        break;
    }
    return fieldComponent;
  }

  formatDateTime(value, previousValue, allValues) {
    let testValue = null;
    if (value) {
      if (!this.DATE_TIME(value)) {
        testValue = moment(value);
      }
      if (testValue.isValid && testValue.isValid()) {
        if (
          testValue.startOf('day').isSameOrBefore(MIN_DATE) ||
          testValue.startOf('day').isSameOrAfter(MAX_DATE)
        ) {
          value = '';
        }
      }
    }
    return value;
  }

  formatString(value) {
    const test = parseInt(value, 10);
    if (!isNaN(test)) {
      return test;
    }
    return value;
  }

  formatBoolean(value) {
    if (value === true || value === 'true') {
      return 1;
    }
    return 0;
  }

  render() {
    const {
      name,
      type,
      label,
      disabled,
      validates,
      value,
      data,
      maxNumber,
      fileName,
      valueKey,
      nameKey,
      className = '',
      maxLength,
      normalizeDateTime,
      fileSize,
      normalizeRadio,
      normalizeSelectBox,
      handleChangeOption,
      inline = true,
      fieldButton,
      fieldInput,
      changeFile,
      accept,
      notAccept,
      treeCheckBox,
      keyArrayToCheck,
      showTime,
      isDateTo,
      normalizeCheckBox,
      shouldDisableDate,
      checkRadioChange,
      radioChange,
      id,
      showMessageErrorFullRows,
      rows,
      shouldDisabledCurrentAndAfter,
      isShowDateInput,
      height,
      readOnly,
      showHour,
      errorClassName,
    } = this.props;
    const validate = this.getValidationFunctions(validates);
    const fieldComponent = this.getFieldComponent(type);
    let normalize = null;
    if (normalizeDateTime) {
      normalize = this.formatDateTime;
    } else if (normalizeRadio || normalizeSelectBox) {
      normalize = this.formatString;
    } else if (normalizeCheckBox) {
      normalize = this.formatBoolean;
    }
    if ((type === 'radio' || type === 'checkbox')) {
      return (
        <label
          className={`${className} ${label ? inline && `${type}-inline` : null} ${disabled && 'disabled'}`}
        >
          <Field
            name={name}
            type={type}
            component={fieldComponent}
            label={label || null}
            disabled={disabled}
            value={value}
            normalize={normalize}
            onChange={(event, newValue, previousValue) => {
              if (checkRadioChange && radioChange) {
                radioChange(event, newValue, previousValue);
              }
            }}
            id={id}
          />
          <span style={{ marginLeft: '5px' }}>
            {label || null}
          </span>
        </label>
      );
    }
    return (
      <Field
        name={name}
        maxLength={maxLength}
        type={type}
        component={fieldComponent}
        label={label}
        validate={validate}
        disabled={disabled}
        data={data}
        value={value}
        errorType={this.errorType}
        fileName={fileName}
        valueKey={valueKey}
        nameKey={nameKey}
        className={className}
        normalize={normalize}
        fileSize={fileSize}
        dateFormat={this.dateFormat}
        handleChangeOption={handleChangeOption}
        fieldButton={fieldButton}
        fieldInput={fieldInput}
        changeFile={changeFile}
        accept={accept}
        notAccept={notAccept}
        treeCheckBox={treeCheckBox}
        keyArrayToCheck={keyArrayToCheck}
        showTime={showTime}
        isDateTo={isDateTo}
        shouldDisableDate={shouldDisableDate}
        showMessageErrorFullRows={showMessageErrorFullRows}
        rows={rows}
        shouldDisabledCurrentAndAfter={shouldDisabledCurrentAndAfter}
        height={height}
        isShowDateInput={isShowDateInput}
        readOnly={readOnly}
        showHour={showHour}
        errorClassName={errorClassName}
      />
    );
  }
}

function getPropertyByKeyPath(targetObj, keyPath) {
  const keys = keyPath.split('.');
  if (keys.length === 0) return undefined;
  let subObject = targetObj;
  while (keys.length) {
    const k = keys.shift();
    if (!Object.prototype.hasOwnProperty.call(subObject, k)) {
      return undefined;
    }
    subObject = subObject[k];
  }
  return subObject;
}

function RequiredArray(props) {
  const {
    input: { disabled, errorType, ...inputProps },
    label,
    type,
    maxLength,
    meta: { error, warning, initial, pristine, submitFailed },
  } = props;
  inputProps.disabled = props.disabled;
  inputProps.errorType = props.errorType;

  return (
    <div>
      <ErrorMessage
        touched={submitFailed}
        submitFailed={submitFailed}
        errorMessage={error}
        label={label}
        errorType={inputProps.errorType}
        pristine={pristine}
      />
    </div>
  );
}

function DateTimeMinMax(props) {
  const {
    input: { disabled, errorType, ...inputProps },
    label,
    type,
    maxLength,
    meta: { error, warning, initial, pristine, submitFailed },
  } = props;
  inputProps.disabled = props.disabled;
  inputProps.errorType = props.errorType;

  return (
    <div>
      <ErrorMessage
        touched={!!error}
        submitFailed={submitFailed}
        errorMessage={error}
        label={label}
        errorType={inputProps.errorType}
        pristine={pristine}
      />
    </div>
  );
}

function SelectInput(props) {
  const {
    input: { disabled, errorType, ...inputProps },
    label,
    type,
    meta: { touched, error, warning, submitFailed, initial, pristine },
  } = props;
  inputProps.disabled = props.disabled;
  inputProps.errorType = props.errorType;
  const valueKey = props.valueKey ? props.valueKey : 'value';
  const nameKey = props.nameKey ? props.nameKey : 'name';
  return (
    <div>
      <SelectBox
        data={props.data}
        name={inputProps.name}
        onChange={(event) => {
          if (!props.handleChangeOption) {
            inputProps.onChange(event);
            return;
          }
          props.handleChangeOption(event.target.value, event.target.name);
          inputProps.onChange(event);
        }}
        valueKey={valueKey}
        nameKey={nameKey}
        value={pristine ? (initial === undefined ? '' : initial) : inputProps.value}
      />
      <ErrorMessage
        touched={touched}
        submitFailed={submitFailed}
        errorMessage={error}
        label={label}
        errorType={inputProps.errorType}
      />
    </div>
  );
}

function disabledDate(current) {
  if (!current) {
    return false;
  }
  return current.isBefore(LIVE_START_MIN_DATE);
}
// #5854 START
function disabledCurrentAndAfter(current) {
  if (!current) {
    return false;
  }
  return current.isAfter(PRECENT_DAY);
}
// #5854 END
function DateTimeInput(props) {
  const {
    input: { disabled, errorType, ...inputProps },
    label,
    type,
    meta: { touched, pristine, initial, error, warning, submitFailed },
    showTime,
    isDateTo,
    shouldDisableDate,
    shouldDisabledCurrentAndAfter,
    isShowDateInput,
    showHour,
  } = props;
  inputProps.disabled = props.disabled;
  inputProps.errorType = props.errorType;
  const newDate = new Date();
  const defaultValue = initial ? moment(initial) : null;
  let timePickerElement = null;
  if (showTime) {
    let defaultTimeValue = moment(newDate, 'HH:mm');
    if (isDateTo) {
      defaultTimeValue = defaultTimeValue.add(1, 'minute');
    }
    timePickerElement = <TimePickerPanel defaultValue={defaultTimeValue} showSecond={false} />;
  }
  let format = DEFAULT_DATE_FORMAT;
  if (showTime) {
    format = DEFAULT_DATE_FORMAT_SHORT_DETAIL;
  }

  if (showHour) {
    let defaultTimeValue = moment(newDate, 'HH:00');
    if (isDateTo) {
      defaultTimeValue = defaultTimeValue.add(1, 'minute');
    }
    timePickerElement = <TimePickerPanel defaultValue={defaultTimeValue} showSecond={false} showMinute={false} format={'HH:00'} />;
    format = DEFAULT_DATE_FORMAT_NO_MINUTE;
  }
  // #5854 START
  let disabledDateCalendar = () => false;
  if (shouldDisableDate) {
    disabledDateCalendar = disabledDate;
  }
  if (shouldDisabledCurrentAndAfter) {
    disabledDateCalendar = disabledCurrentAndAfter;
  }
  
  // #5854 END
  const calendar = (
    <Calendar
      showDateInput={isShowDateInput}
      showWeekNumber={false}
      showToday={false}
      animation="slide-up"
      showTime={showTime}
      showOk={showTime}
      locale={jaJPCustom} // #7259
      format={format}
      defaultValue={defaultValue}
      timePicker={timePickerElement}
      disabledDate={disabledDateCalendar}
    />
  );

  let dateValue =
    inputProps.value && inputProps.value.format ? inputProps.value.format(format) : '';
  if (!dateValue) {
    dateValue = pristine ? (initial ? moment(initial).format(format) : '') : '';
  }
  return (
    <div>
      <InputGroup className={'calendar-dropdown'}>
        <Picker
          animation="slide-up"
          calendar={calendar}
          onChange={inputProps.onChange}
          getCalendarContainer={(element) => {
            if (
              !element ||
              !$(element).parent() ||
              !$(element)
                .parent()
                .parent() ||
              !$(element)
                .parent()
                .parent().length
            ) {
              return document.body;
            }
            return $(element)
              .parent()
              .parent()[0];
          }}
          defaultValue={defaultValue}
          value={pristine ? defaultValue : inputProps.value || null}
        >
          {({ value }) => (
            <FormControl
              type="text"
              className="ant-calendar-picker-input ant-input"
              value={dateValue}
              readOnly
              disabled={props.disabled}
            />
          )}
        </Picker>
        <InputGroup.Text onClick={!props.disabled ? handleCalendarIconClick : null} className={props.className}>
          {' '}
          <i className="bi bi-calendar3" />
        </InputGroup.Text>
      </InputGroup>
      <ErrorMessage
        touched={touched}
        submitFailed={submitFailed}
        errorMessage={error}
        label={label}
        errorType={inputProps.errorType}
        pristine={pristine}
      />
    </div>
  );
}

function TextBox(props) {
  const {
    input: { disabled, errorType, ...inputProps },
    label,
    type,
    maxLength,
    meta: { touched, error, warning, initial, pristine, submitFailed },
    className,
    errorClassName,
  } = props;
  inputProps.disabled = props.disabled;
  inputProps.errorType = props.errorType;
  let classNameData = '';
  if (className) {
    classNameData = className;
  }
  return (
    <div>
      <FormControl
        type={type}
        name={inputProps.name}
        onChange={inputProps.onChange}
        onBlur={inputProps.onBlur}
        maxLength={maxLength || 256}
        disabled={inputProps.disabled}
        hidden={inputProps.hidden}
        value={pristine ? (initial === undefined ? '' : initial) : inputProps.value}
        className={classNameData}
      />
      <ErrorMessage
        touched={touched}
        submitFailed={submitFailed}
        errorMessage={error}
        label={label}
        errorType={inputProps.errorType}
        errorClassName={errorClassName}
      />
    </div>
  );
}

function TextArea(props) {
  const {
    input: { disabled, errorType, ...inputProps },
    label,
    type,
    meta: { touched, error, warning, initial, pristine, submitFailed },
    className,
    maxLength,
    rows,
    height,
    readOnly,
  } = props;
  inputProps.disabled = props.disabled;
  inputProps.errorType = props.errorType;
  return (
    <div>
      <FormControl
        as="textarea"
        name={inputProps.name}
        onChange={inputProps.onChange}
        onBlur={inputProps.onBlur}
        disabled={inputProps.disabled}
        hidden={inputProps.hidden}
        value={pristine ? (initial === undefined ? '' : initial) : inputProps.value}
        className={className}
        maxLength={maxLength || 2048}
        rows={rows}
        style={{ height: `${height}px` }}
        readOnly={readOnly}
      />
      <ErrorMessage
        touched={touched}
        submitFailed={submitFailed}
        errorMessage={error}
        label={label}
        errorType={inputProps.errorType}
      />
    </div>
  );
}

function FileUpload(props) {
  const {
    input: { disabled, errorType, ...inputProps },
    label,
    type,
    meta: { touched, error, warning, submitFailed },
  } = props;
  inputProps.disabled = props.disabled;
  inputProps.errorType = props.errorType;

  const inputName = inputProps.name;
  const id = inputName.replace('.', '');

  return (
    <Col className="fileinput fileinput-new" data-provides="fileinput">
      <label
        htmlFor={id}
        className="btn btn-primary float-start button-form btn-96 margin-clear"
        disabled={inputProps.disabled}
      >
        {label}
      </label>
      <FormControl
        id={id}
        type="file"
        className="hidden"
        onChange={(event) => {
          if (props.changeFile && typeof props.changeFile === 'function') {
            props.changeFile(event);
          }
          inputProps.onChange(event);
        }}
        name={inputProps.name}
        disabled={inputProps.disabled}
        accept={props.accept}
      />
      <ErrorMessage
        touched={touched}
        submitFailed={submitFailed}
        errorMessage={error}
        label={label}
        errorType={inputProps.errorType}
      />
    </Col>
  );
}

function BatchImport(props) {
  const {
    input: { disabled, errorType, ...inputProps },
    label,
    type,
    meta: { touched, error, warning, pristine, submitFailed },
  } = props;
  inputProps.disabled = props.disabled;
  inputProps.errorType = props.errorType;
  const accept = props.accept
    ? props.accept
    : 'application/zip,application/x-zip,application/x-zip-compressed';
  return (
    <div>
      <Form.Group style={{ marginBottom: '0px' }}>
        <Col sm={12}>
          <Col sm={props.fieldInput || 5} className="padding-clear">
            <FormControl type="text" name="file_upload" value={props.fileName} disabled />
          </Col>
          <Col sm={props.fieldButton || 7} className="fileinput fileinput-new padding-right-clear padding-left-15" data-provides="fileinput">
            <label
              htmlFor={inputProps.name}
              className="btn btn-primary button-form btn-120 margin-clear"
              disabled={inputProps.disabled}
            >
              {label}
            </label>
            <FormControl
              id={inputProps.name}
              type="file"
              className="hidden"
              // sprint_20230403-UT-001 START
              onChange={(event) => {
                if (props.changeFile && typeof props.changeFile === 'function') {
                  props.changeFile(event, inputProps.name);
                }
                inputProps.onChange(event);
              }}
              // sprint_20230403-UT-001 END
              disabled={inputProps.disabled}
              accept={accept}
            />
          </Col>
        </Col>
        <Col sm={12} style={{ marginTop: '-10px' }}>
          <Col sm={props.showMessageErrorFullRows ? 12 : (props.fieldInput || 5)} className="padding-clear">
            <ErrorMessage
              touched={touched}
              submitFailed={submitFailed}
              errorMessage={error}
              label={inputProps.errorType === ERROR_TYPE.EMPTY ? label : ''} // Don not show label in error message
              errorType={inputProps.errorType}
            />
          </Col>
        </Col>
      </Form.Group>
    </div>
  );
}

function ThumbnailImport(props) {
  const {
    input: { disabled, errorType, ...inputProps },
    label,
    type,
    meta: { touched, error, warning, pristine, submitFailed },
  } = props;
  inputProps.disabled = props.disabled;
  inputProps.errorType = props.errorType;
  return (
    <div>
      <Form.Group style={{ marginBottom: '0px' }}>
        <Col sm={7} className="col-sm-offset-3" style={{ paddingLeft: 0 }}>
          <FormControl type="text" name="file_upload" re value={props.fileName} />
        </Col>
        <Col sm={2} className="fileinput fileinput-new" data-provides="fileinput">
          <label
            htmlFor={inputProps.name}
            className="btn btn-primary float-start button-form btn-96 margin-clear"
            disabled={inputProps.disabled}
          >
            {label}
          </label>
          <FormControl
            id={inputProps.name}
            type="file"
            className="hidden"
            onChange={inputProps.onChange}
            disabled={inputProps.disabled}
          />
        </Col>
        <Col sm={7} className="col-sm-offset-3" style={{ paddingLeft: 0 }}>
          <ErrorMessage
            touched={touched}
            submitFailed={submitFailed}
            errorMessage={error}
            label={label}
            errorType={inputProps.errorType}
          />
        </Col>
      </Form.Group>
    </div>
  );
}

function TreeComponent(props) {
  const {
    input: { errorType, ...inputProps },
    data,
    label,
    type,
    meta: { touched, error, warning, submitFailed },
    treeCheckBox,
    openAll,
  } = props;
  return (
    <div>
      <ErrorMessage
        touched={touched}
        submitFailed={submitFailed}
        errorMessage={error}
        label={label}
        errorType={inputProps.errorType}
      />
      {data && data.length > 0 ? (
        <TreeView
          data={data}
          openAll={openAll} // 20230605_tma
          isNotRefresh
          onSelectNode={(event, selectedNode) => {
            if (treeCheckBox) {
              return;
            }
            inputProps.onChange(selectedNode.data);
          }}
          onSelectCheckbox={(e, nodes) => {
            if (!treeCheckBox) {
              return;
            }
            let selectedGroupIds = [];
            if (nodes && nodes.selected) {
              selectedGroupIds = nodes.selected;
            }
            inputProps.onChange(selectedGroupIds);
          }}
          checkbox={treeCheckBox}
          threeState={false}
        />
      ) : null}
    </div>
  );
}

function getFileExtension(fileName) {
  if (!fileName) return '';
  return fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2);
}

function messageTemplate(label, msg) {
  return msg.replace('{0}', label);
}

function messageMaxNumberTemplate(label, maxNumber, msg) {
  msg = msg.replace('{0}', label);
  return msg.replace('{1}', maxNumber);
}

function messageMinMaxNumberTemplate(label, minNumber, maxNumber, msg) {
  msg = msg.replace('{0}', label);
  msg = msg.replace('{1}', minNumber);
  return msg.replace('{2}', maxNumber);
}

function ErrorMessage(props) {
  const { errorMessage, errorType, touched, label, submitFailed, pristine, errorClassName } = props;
  const shouldDisplay = (touched || submitFailed) && errorMessage;
  const style = shouldDisplay ? { marginTop: '5px' } : {};
  if (shouldDisplay) {
    return (
      <div className={errorClassName} style={{ marginTop: '5px' }}>
        {/* {(touched || submitFailed) &&
          errorMessage && ( */}
        <p
          className={getErrorClass(errorType)}
          style={{
            marginTop: '1px',
            fontWeight: 'bold',
            paddingTop: '7px',
            paddingBottom: '7px',
            marginBottom: '0px',
          }}
        >
          {label}
          {errorMessage}
        </p>
        {/* )} */}
      </div>
    );
  }
  return (
    <div />
  );
}

function getErrorClass(errorType) {
  switch (errorType) {
    case ERROR_TYPE.PRIMARY:
      return 'alert alert-info';
    case ERROR_TYPE.SUCCESS:
      return 'alert alert-success';
    case ERROR_TYPE.ERROR:
      return 'alert alert-danger';
    case ERROR_TYPE.WARNING:
      return 'alert alert-warning';
    case ERROR_TYPE.EMPTY:
      return 'alert alert-danger';
    default:
      return '';
  }
}

export default RenderField;
